module.exports = __webpack_public_path__ + "media/assets/AirboLogo-d73b666cf2f6207572e5aff8c246568d.svg";